import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  wrapper: {
    width: '100%',
  },
  inputContainer: {
    position: 'relative',
  },
  unitsLabel: {
    position: 'absolute',
    top: '50%',
    right: 16,
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.6)',
    transform: 'translateY(-50%)',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  inputWrapper: {
    boxSizing: 'border-box',
    width: '100%',
    fontSize: 16,
    border: '1px solid #FF8C69',
    fontFamily: 'Roboto',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    '&:before': {
      display: 'none',
    },
    '&:after': {
      display: 'none',
    },
    '& input': {
      height: 'auto',
    },
    '& input::placeholder, & .MuiTypography-colorTextSecondary': {
      color: '#213332',
      opacity: 1,
    },
    '&.Mui-error': {
      borderColor: '#ff6770',
    },
  },
  input: {
    padding: 15,
  },
  inputWithUnits: {
    paddingRight: 57,
  },
  helperText: {
    fontSize: 16,
    color: '#000000',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
  },
  inputLabel: {
    marginBottom: 10,
    fontSize: 16,
    color: '#000000',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    '.rtl &': {
      display: 'flex',
      textAlign: 'unset',
    },
  },
  redText: {
    color: '#ff5660',
  },
  redError: {
    color: '#ff5660',
    position: 'absolute',
    left: 0,
    bottom: -22,
  },
  required: {
    color: '#ff5660',
    '.rtl &': {
      marginRight: 3,
    },
  },
  errorWrapper: {
    position: 'relative',
    maxWidth: ({ provider }) => (provider ? '100%' : 330),
  },
  inputError: {
    background: 'rgba(255, 86, 96, 0.05)',
    border: '1px solid #FF6770',
    color: '#FF5660',
  },
}));
